import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSearchParams } from './use-search-params';

type PlacementSearchParams = {
    returnTo?: string;
};

export const usePlacementLinking = () => {
    const history = useHistory();
    const search = useSearchParams<PlacementSearchParams>();

    const returnTo = search.params.returnTo;

    const redirectAfterCreate = React.useCallback(
        (fallback: () => void) => {
            if (returnTo) {
                history.replace(returnTo);
            } else {
                fallback();
            }
        },
        [history, returnTo]
    );

    return {
        redirectAfterCreate,
    };
};
